import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {UploadFile} from 'views/module';
import {PhotoCamera as PhotoCameraIcon} from 'views/icons';

const CaregiverPhoto = (props) => {
  const [reload, setReload] = React.useState(0);
  const [onHover, setOnHover] = React.useState(false);

  const {
    caregiverData,
    caregiverBackend,
  } = props;

  const profileImg = caregiverData.profileImg;

  const handleUpload = (file) => {
    if (file) {
      caregiverBackend.detail.editPhoto(file, () => setReload((e) => e + 1));
    }
  };

  return (
    <UploadFile
      uploadFile={handleUpload}
    >
      <Box
        sx={{
          textAlign: 'center',
          margin: 4,
          maxWidth: {md: '200px', xs: '100%'},
          maxHeight: '200px',
          cursor: 'pointer',
        }}
        onMouseEnter={() => setOnHover(true)}
        onMouseLeave={() => setOnHover(false)}
      >
        <Box
          sx={{
            marginTop: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 200,
            width: '100%',
            border: 1,
            borderColor: 'grey.400',
            borderRadius: '24px',
            bgcolor: 'background.default',
            position: 'relative',
            overflow: 'hidden',
            bgcolor: 'grey.200',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              display: 'flex',
              bgcolor: 'rgb(252, 253, 255, 0.5)',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: onHover ? 3 : 1,
            }}
          >
            <PhotoCameraIcon
              fontSize="large"
              color="action"
            />
          </Box>
          {
            profileImg &&
            <img
              src={`${profileImg}?${reload}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                background: 'white',
                zIndex: 2,
              }}
            />
          }
        </Box>
      </Box>
    </UploadFile>
  );
};
CaregiverPhoto.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(CaregiverPhoto);
